import growthSocialLogo from "@/assets/growth-social-logo.png";
import growthSocialLogoDark from "@/assets/growth-social-logo-dark.png";
import { BRANDING } from "@/lib/branding";

interface GrowthSocialLogoProps {
  variant?: 'light' | 'dark' | 'auto';
  height?: number;
  className?: string;
  animate?: boolean;
}

export const GrowthSocialLogo = ({ 
  variant = 'light', 
  height = 32, 
  className = '', 
  animate = false 
}: GrowthSocialLogoProps) => {
  const logoSrc = variant === 'dark' ? growthSocialLogoDark : growthSocialLogo;
  // Logo typical aspect ratio ~3:1
  const width = height * 3;
  
  return (
    <img
      src={logoSrc}
      alt={`${BRANDING.PRODUCT_NAME} - The Social Media Platform for B2B SaaS`}
      width={width}
      height={height}
      loading="eager"
      fetchPriority="high"
      decoding="async"
      style={{ height: `${height}px`, width: 'auto' }}
      className={`
        object-contain object-left
        ${animate ? 'transition-transform duration-200 hover:scale-105' : ''}
        ${className}
      `.trim()}
    />
  );
};
